import React, { FC } from 'react';

const IconPercentageArrowUp: FC = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 0L10 7H0L5 0Z" fill="#29A70F" />
    </svg>
  );
};

export default IconPercentageArrowUp;
